import { gql } from './apollo';

export const GET_CONTACTS_FILTER_BY_ACCOUNT_ID_AND_NAME_OR_EMAIL_OR_PHONE = gql`
    query ($accountid: MultiTypeInput!, $search: MultiTypeInput = "%", $limit: Int = 20) {
        table(
            name: "contact"
            filter: [
                { table: "contact", left: "accountid", right: $accountid, expression: "=" }
                {
                    or_: [
                        { table: "contact", left: "name", right: $search, expression: "iLIKE" }
                        { table: "contact", left: "email", right: $search, expression: "iLIKE" }
                        { left: "phone", right: $search, expression: "iLIKE" }
                    ]
                }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            orderBy: "firstname"
            limit: $limit
        )
    }
`;

export const GET_CONTACTS_BY_ACCOUNT_AND_ORDER_NUMBER = gql`
    query ($accountid: MultiTypeInput!, $like: MultiTypeInput = "%", $limit: Int = 20) {
        table(
            name: "contact"
            join: [{ table: "order", fk: "contact__c", joinFk: "sfid" }]
            contain: [
                {
                    table: "order"
                    columns: ["external_id__c", "vts_id", "ecomm"]
                    fk: "contact__c"
                    joinFk: "sfid"
                    limit: 1
                    where: [
                        {
                            or_: [
                                {
                                    table: "order"
                                    left: "vts_id"
                                    right: $like
                                    expression: "iLIKE"
                                }
                                {
                                    and_: [
                                        {
                                            table: "order"
                                            left: "external_id__c"
                                            right: $like
                                            expression: "iLIKE"
                                        }
                                        {
                                            table: "order"
                                            left: "ecomm"
                                            right: "true"
                                            expression: "="
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
            filter: [
                { table: "contact", left: "accountid", right: $accountid, expression: "=" }
                { table: "order", left: "status", right: "Activated", expression: "=" }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
                {
                    or_: [
                        { table: "order", left: "vts_id", right: $like, expression: "iLIKE" }
                        {
                            and_: [
                                {
                                    table: "order"
                                    left: "external_id__c"
                                    right: $like
                                    expression: "iLIKE"
                                }
                                { table: "order", left: "ecomm", right: "true", expression: "=" }
                            ]
                        }
                    ]
                }
            ]
            orderBy: "name"
            limit: $limit
        )
    }
`;

export const GET_CONTACT_BY_EMAIL_FOR_ACCOUNT = gql`
    query ($accountid: MultiTypeInput!, $email: MultiTypeInput!) {
        table(
            name: "contact"
            filter: [
                { left: "email", right: $email, expression: "=" }
                { left: "accountid", right: $accountid, expression: "=" }
                { left: "sfid", right: "null", expression: "!=" }
            ]
        )
    }
`;

export const CREATE_CONTACT = gql`
    mutation (
        $name: MultiTypeInput
        $firstname: MultiTypeInput
        $lastname: MultiTypeInput
        $email: MultiTypeInput
        $phone: MultiTypeInput
        $accountid: MultiTypeInput
        $sfid: MultiTypeInput
        $optin_email: MultiTypeInput
        $optin_source: MultiTypeInput
        $optin_date: MultiTypeInput
        $optin_type: MultiTypeInput
        $optin_other: MultiTypeInput
        $createddate: MultiTypeInput
        $hvc__c: MultiTypeInput
        $hvc_last_modified_by__c: MultiTypeInput = ""
        $language: MultiTypeInput
        $ott_customer: MultiTypeInput
    ) {
        createRow(
            table: "contact"
            values: [
                { property: "name", value: $name }
                { property: "firstname", value: $firstname }
                { property: "lastname", value: $lastname }
                { property: "email", value: $email }
                { property: "phone", value: $phone }
                { property: "language", value: $language }
                { property: "accountid", value: $accountid }
                { property: "sfid", value: $sfid }
                { property: "optin_other", value: $optin_other }
                { property: "optin_email", value: $optin_email }
                { property: "optin_source", value: $optin_source }
                { property: "optin_date", value: $optin_date }
                { property: "optin_type", value: $optin_type }
                { property: "createddate", value: $createddate }
                { property: "systemmodstamp", value: $createddate }
                { property: "isdeleted", value: false }
                { property: "hvc__c", value: $hvc__c }
                { property: "hvc_last_modified_by__c", value: $hvc_last_modified_by__c }
                { property: "ott_customer", value: $ott_customer }
            ]
        )
    }
`;

export const UPDATE_CONTACT = gql`
    mutation (
        $id: String!
        $name: MultiTypeInput
        $firstname: MultiTypeInput
        $lastname: MultiTypeInput
        $email: MultiTypeInput
        $phone: MultiTypeInput
        $accountid: MultiTypeInput
        $optin_email: MultiTypeInput
        $optin_source: MultiTypeInput
        $optin_date: MultiTypeInput
        $optin_type: MultiTypeInput
        $optin_other: MultiTypeInput
        $hvc__c: MultiTypeInput
        $hvc_last_modified_by__c: MultiTypeInput
        $language: MultiTypeInput
        $ott_customer: MultiTypeInput
    ) {
        updateRow(
            table: "contact"
            id: $id
            values: [
                { property: "name", value: $name }
                { property: "firstname", value: $firstname }
                { property: "lastname", value: $lastname }
                { property: "email", value: $email }
                { property: "phone", value: $phone }
                { property: "language", value: $language }
                { property: "accountid", value: $accountid }
                { property: "optin_other", value: $optin_other }
                { property: "optin_email", value: $optin_email }
                { property: "optin_source", value: $optin_source }
                { property: "optin_date", value: $optin_date }
                { property: "optin_type", value: $optin_type }
                { property: "hvc__c", value: $hvc__c }
                { property: "hvc_last_modified_by__c", value: $hvc_last_modified_by__c }
                { property: "ott_customer", value: $ott_customer }
            ]
        )
    }
`;
